<script setup>
import { onMounted, ref } from 'vue';

const model = defineModel({
    type: String,
    required: true,
});

const input = ref(null);

onMounted(() => {
    if (input.value.hasAttribute('autofocus')) {
        input.value.focus();
    }
});

defineExpose({ focus: () => input.value.focus() });
</script>

<template>
    <input
        ref="input"
        v-model="model"
        class="block w-full rounded-md border-2 border-primary-500 bg-primary-800 px-3 py-2.5 text-sm text-primary-100 shadow-none outline-none transition-colors placeholder:text-primary-500 focus:border-accent-500 focus:ring-2 focus:ring-accent-500/70"
    />
</template>
